import { StateChangeHandlerFxn } from 'common.types'
import i18n from '../../../../i18n'
const voterRegistrationStateChangeHandler: StateChangeHandlerFxn = (
  key,
  prevValue,
  newValue,
  setFormState,
  state,
) => {
  const { t } = i18n
  if (key === 'mailinBallotAddressType') {
    if (newValue === 'R') {
      let newAddress = `${state.address ?? ''}`
      if (state.unitType) {
        newAddress +=
          ', ' +
          t(`voterRegistrationForm.fields.unitType.options.${state.unitType}`)
      }
      if (state.unitNumber) {
        newAddress += ' ' + state.unitNumber
      }
      if (state.addressTwo) {
        newAddress += ', ' + state.addressTwo
      }
      setFormState((prevState) => {
        return {
          ...prevState,
          mailinBallotAddress: newAddress.substring(0, 40),
          mailinBallotCity: state.city ?? '',
          mailinBallotState: 'PA',
          mailinBallotZip: state.zip ?? '',
        }
      })
    }
    if (newValue === 'M') {
      setFormState((prevState) => {
        return {
          ...prevState,
          mailinBallotAddress: state.altAddress ?? '',
          mailinBallotCity: state.altCity ?? '',
          mailinBallotState: state.altState ?? '',
          mailinBallotZip: state.altZip ?? '',
        }
      })
    }
    if (newValue === 'A') {
      setFormState((prevState) => {
        return {
          ...prevState,
          mailinBallotAddress: '',
          mailinBallotCity: '',
          mailinBallotState: '',
          mailinBallotZip: '',
        }
      })
    }
  }
  if (key === 'reasonChangeOfAddress') {
    setFormState((prevState) => {
      return {
        ...prevState,
        previousState: newValue ? 'PA' : undefined,
      }
    })
  }
  if (key === 'noPennDotId') {
    setFormState((prevState) => {
      const newState = { ...prevState }
      ;['idCardNumber'].forEach((prop) => {
        if (prop in newState) {
          newState[prop] = undefined
        }
      })
      return newState
    })
  }
  if (key === 'noId') {
    setFormState((prevState) => {
      const newState = { ...prevState }
      ;['ssnLastFour'].forEach((prop) => {
        if (prop in newState) {
          newState[prop] = undefined
        }
      })
      return newState
    })
  }
  if (key === 'reasonNewRegistration') {
    setFormState((prevState) => {
      const newState = { ...prevState }
      ;[
        'reasonChangeOfName',
        'previousFirstName',
        'previousLastName',
        'reasonChangeOfAddress',
        'previousAddress',
        'previousCity',
        'previousState',
        'previousZip',
        'previousCounty',
        'previousYear',
        'reasonChangeOfParty',
      ].forEach((prop) => {
        if (prop in newState) {
          newState[prop] = undefined
        }
      })
      return newState
    })
  }
  if (key === 'idCardNumber' && prevValue && !newValue) {
    setFormState((prevState) => {
      const newState = { ...prevState }
      ;[
        'mailinBallotInterest',
        'mailinBallotAddressType',
        'mailinBallotAddress',
        'mailinBallotInterest',
        'mailinBallotCity',
        'mailinBallotState',
        'mailinBallotZip',
        'ward',
        'livedSince',
        'mailinBallotConfirmation',
      ].forEach((prop) => {
        if (prop in newState) {
          newState[prop] = undefined
        }
      })
      return newState
    })
  }
  return true
}

export default voterRegistrationStateChangeHandler
